<div class="settings-card">
    <div class="settings-card__header">
        <img src="/assets/images/Group 24.svg" alt="" />
        <div class="settings-card__header-headline">
            <h2>Scanări</h2>
        </div>
    </div>
</div>

<div class="requests-page">
    <div class="content-box">
        <div class="row">
            <div class="col-sm-12">
                <div class="section">
                    <div class="section-top">
                        <h3 class="section-title">Scanări</h3>
                        <div class="section-top-actions">
                            <button type="button" class="btn btn-sm btn-info pull-right ms-1"
                                (click)="rerenderDT(false)">
                                <i class="fa-solid fa-arrows-rotate"></i>
                            </button>
                            <button *ngIf="permissionsService.hasPermission('dgaspc-module.copii.add')" type="button"
                                class="btn btn-sm btn-primary pull-right ms-1" (click)="openAddDialog()">
                                <i class="fa-solid fa-plus"></i>
                                Adaugă
                            </button>
                        </div>
                    </div>

                    <div class="card-container request-filter p-2" *ngIf="showCard">
                        <form [formGroup]="searchParamsForm" (ngSubmit)="applyFilters()">
                            <br />
                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Denumire</mat-label>
                                        <input matInput formControlName="denumire" />
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Încărcat de</mat-label>
                                        <mat-select formControlName="incarcat_de">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let operator of operatori" [value]="operator.id">
                                                {{ operator.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Operator asignat</mat-label>
                                        <mat-select formControlName="operator_asignat">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let operator of operatori" [value]="operator.id">
                                                {{ operator.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Entitate</mat-label>
                                        <mat-select formControlName="entity_id"
                                            (openedChange)="onEntitatiSelectClosed()">
                                            <mat-form-field class="px-2 w-100 sticky-input">
                                                <input matInput [formControl]="entitatiControl"
                                                    (keydown)="$event.stopPropagation()"
                                                    (click)="$event.stopPropagation()" />
                                            </mat-form-field>

                                            <mat-option *ngIf="filteredEntitati.length === 0" disabled>
                                                <span>No results found</span>
                                            </mat-option>

                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let entitate of filteredEntitati" [value]="entitate.id">
                                                {{ entitate.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Status</mat-label>
                                        <mat-select formControlName="status">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let status of documentStatuses" [value]="status.id">
                                                {{ status.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <div class="col-md-6">
                                    <mat-form-field class="w-100">
                                        <mat-label>Prioritate</mat-label>
                                        <mat-select formControlName="prioritate">
                                            <mat-option [value]="-1">-- Alegeți --</mat-option>
                                            <mat-option *ngFor="let priority of documentPriorities"
                                                [value]="priority.id">
                                                {{ priority.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col d-flex justify-content-start">
                                    <button (click)="toggleCard()" type="button"
                                        class="btn btn-sm btn-warning closeBtn">
                                        Închide
                                    </button>
                                </div>
                                <div class="col buttons-submit">
                                    <button (click)="resetForm()" type="button" class="btn btn-sm btn-secondary">
                                        Resetează
                                    </button>
                                    <button type="submit" class="btn btn-sm btn-primary ms-2">
                                        Aplică
                                    </button>
                                </div>
                            </div>
                        </form>
                        <div class="section-spinner position-absolute" *ngIf="isFilterLoading">
                            <div class="spinner position-absolute top-50 start-50 translate-middle">
                                <mat-spinner></mat-spinner>
                                <h3 class="mt-2">
                                    {{ helper.dialogConfig.generalMessages.pleaseWait }}
                                </h3>
                            </div>
                        </div>
                    </div>

                    <div class="row d-flex p-2">
                        <div class="col d-flex justify-content-start">
                            <button class="action-button" (click)="toggleCard()" [class.active]="showCard">
                                <img src="assets/images/filter-icon.png" alt="Filtrare" />
                                <span>Filtre</span>
                            </button>
                        </div>
                        <div class="col d-flex justify-content-end">
                            <button type="button" class="btn btn-light action-button" [popover]="popTemplate"
                                [adaptivePosition]="true" container="body" boundariesElement="viewport"
                                placement="left">
                                <img src="assets/icons/calendar-icon.svg" alt="Calendar" />
                                <span>{{ selectedStartDate | date : "dd.MM.yyyy" }} - {{ selectedEndDate | date :
                                    "dd.MM.yyyy"
                                    }}
                                </span>
                            </button>

                            <!-- Popover Template below-->
                            <ng-template #popTemplate>
                                <div class="popover">
                                    <div class="row">
                                        <div class="col d-flex justify-content-between">
                                            <h2>Selectați intervalul</h2>
                                            <button style="height: 40px; width: 100px" class="btn btn-light close-btn"
                                                (click)="closePopover()">
                                                <img src="assets/icons/close.svg" alt="Închide"
                                                    style="height: 20px; width: 20px" />
                                                <span class="close-text">ÎNCHIDE</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="row mt-2 mb-2">
                                        <div class="col d-flex justify-content-between">
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_0_days'
                                                " (click)="setLastXDays(0)">
                                                <span>AZI</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_7_days'
                                                " (click)="setLastXDays(7)">
                                                <span>7 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'last_30_days'
                                                " (click)="setLastXDays(30)">
                                                <span>30 ZILE</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'current_year'
                                                " (click)="setYear(0)">
                                                <span>AN CURENT</span>
                                            </button>
                                            <button type="button" class="action-button" [class.selected]="
                                                selectedFilteringButton === 'previous_year'
                                                " (click)="setYear(1)">
                                                <span>AN ANTERIOR</span>
                                            </button>
                                        </div>
                                    </div>
                                    <div class="datepicker-container">
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">DE LA:</div>
                                                <div class="date">
                                                    {{ selectedStartDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #startCalendar [startAt]="selectedStartDate"
                                                    [(selected)]="selectedStartDate" [maxDate]="today"
                                                    [maxDate]="selectedEndDate"></mat-calendar>
                                            </mat-card>
                                        </div>
                                        <div class="col">
                                            <div class="datepicker-header">
                                                <div class="text">PÂNĂ LA:</div>
                                                <div class="date">
                                                    {{ selectedEndDate | date : "mediumDate" }}
                                                </div>
                                            </div>
                                            <mat-card>
                                                <mat-calendar #endCalendar [(selected)]="selectedEndDate"
                                                    [maxDate]="today"></mat-calendar>
                                            </mat-card>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>

                    <div class="table-container">
                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover w-100">
                        </table>
                    </div>
                    <div class="section-spinner position-absolute" *ngIf="isLoading">
                        <div class="spinner position-absolute top-50 start-50 translate-middle">
                            <mat-spinner></mat-spinner>
                            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>